import { Action, createReducer, on } from '@ngrx/store';
import { AddressBooksTableState } from './address-books-table.state';
import {
    addressBooksTableChangePage, addressBooksTableChangeQuery,
    addressBooksTableFailure, addressBooksTableMasterToggle,
    addressBooksTableRequest, addressBooksTableSetSelection, addressBooksTableSort,
    addressBooksTableSuccess, addressBooksTableToggle
} from './address-books-table.actions';

const initialState: AddressBooksTableState = {
    query: {
        sortColumn: 'id',
        sortDescending: false,
        filter: null,
        pageNumber: 1,
        itemsPerPage: 25
    },
    page: [],
    totalCount: null,
    filteredCount: null,
    busy: false,
    error: false,
    selection: []
};

const reducer = createReducer(
    initialState,
    on(addressBooksTableRequest, (state) => ({
        ...state,
        busy: true,
        error: false
    })),
    on(addressBooksTableSuccess, (state, { totalCount, page }) => ({
        ...state,
        busy: false,
        page,
        totalCount,
        error: false
    })),
    on(addressBooksTableFailure, (state) => ({
        ...state,
        busy: false,
        error: true
    })),
    on(addressBooksTableChangePage, (state, { pageNumber, itemsPerPage }) => ({
        ...state,
        selection: [],
        query: { ...state.query, pageNumber, itemsPerPage }
    })),
    on(addressBooksTableChangeQuery, (state, { query }) => ({
        ...state,
        query
    })),
    on(addressBooksTableSort, (state, { id, descending }) => ({
        ...state,
        query: { ...state.query, sortColumn: id, sortDescending: descending }
    })),
    on(addressBooksTableSetSelection, (state, { selection }) => ({
        ...state,
        selection
    })),
    on(addressBooksTableToggle, (state, { id }) => ({
        ...state,
        selection: state.selection.indexOf(id) === -1 ? [ ...state.selection, id ] : state.selection.filter((sid) => sid !== id)
    })),
    on(addressBooksTableMasterToggle, (state) => ({
        ...state,
        selection: state.selection.length === 0 ? state.page.map(h => h.id) : []
    }))
);

export function addressBooksTableReducer(state: AddressBooksTableState | undefined, action: Action): any {
    return reducer(state, action);
}
